export default __webpack_public_path__ + "static/media/dj0.aaac47c0.png";